// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Source component — enum, not string. 1 byte on wire.
 */
export enum SourceComponent {
  Wvs = 0,
  Vts = 1,
  Edge = 2,
  Cloud = 3,
  Frontend = 4,
  Diligent = 5,
  Nyct = 6,
  Integrator = 7,
}
